/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="84.32"
        viewBox="0 0 95.58 84.32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M69.03 0a26.12 26.12 0 0 0-18 7.63l-3.24 3.25-3.24-3.25A26.29 26.29 0 0 0 7.11 8c-9.83 10.24-9.38 26.73.8 36.92l39 39a1.25 1.25 0 0 0 1.77 0l39-39c10.18-10.19 10.63-26.68.8-36.91a26.2 26.2 0 0 0-19-8Zm.47 2.5a23.71 23.71 0 0 1 17.17 7.28l.28.29c8.58 9.26 8.09 24-1 33.12L47.79 81.3 9.68 43.19C.5 34 .04 19 8.91 9.78a23.78 23.78 0 0 1 33.87-.38l4.13 4.13a1.26 1.26 0 0 0 1.77 0L52.8 9.4a23.6 23.6 0 0 1 16.7-6.9Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M71.32 15.09v9.19h9.19v9.97h-9.19v9.19h-9.98v-9.19h-9.18v-9.97h9.18v-9.19h9.98z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HeartWithCrossIcon';

export default Icon;
